import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Chip,
  Stack,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import LearningCalendarData from "./LearningCalendarData.json";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSessions,
  downloadFile,
  fetchTimeZone
} from "../../Redux/AdminSlice";

const LearningCalendarFilters = ({
  onFilterChange,
  startDate,
  endDate,
  setDateRange,
}) => {
  const [capability, setCapability] = useState("");
  const [category, setCategory] = useState("");
  const [targetAudience, setTargetAudience] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [modeDelivery, setModeDelivery] = useState("");
  const [timezone,setTimeZone]  = useState("")
  const dispatch = useDispatch();
  const { sessions: DBData } = useSelector((state) => state.admin);
  const {timeZone} = useSelector((state)=>state.admin);

  const handleDownload = () => {
    const filters = {
      capability,
      category,
      targetAudience,
      searchTerm,
      startDate,
      endDate,
      modeDelivery,
      timezone
    };

    dispatch(downloadFile(filters));
  };
  useEffect(() => {
    dispatch(fetchSessions());
    dispatch(fetchTimeZone());
  }, [dispatch]);

 const uniqueValues = (key) => {
  if (!Array.isArray(DBData)) return [];
  return Array.from(
    new Set(
      DBData.map((item) =>
        item[key]?.toString().trim().replace(/\s+/g, " ")
      ).filter(Boolean)
    )
  );
};
const requireValue = () =>{
  if (!Array.isArray(timeZone)) return [];
  return (
  Array.from(
    new Set(
      timeZone.map((item) =>({
       Region: item.Cluster.split(" ")[1],
       Country: item.TimeZoneId,
       TimeZoneId:item.TimeZoneId
      })
      ).filter(Boolean))
    )
  );
}
  // useEffect(()=>{
  //   const data = requireValue()
  //   setTimeZone(data)
  // },[timezone])
  useEffect(() => {
    onFilterChange({
      capability,
      category,
      modeDelivery,
      targetAudience,
      searchTerm,
      startDate,
      endDate,
      timezone
    });
  }, [
    capability,
    category,
    modeDelivery,
    targetAudience,
    searchTerm,
    startDate,
    endDate,
    timezone
  ]);

  const handleDelete = (filterKey) => {
    if (filterKey === "capability") setCapability("");
    else if (filterKey === "category") setCategory("");
    else if (filterKey === "modeDelivery") setModeDelivery("");
    else if (filterKey === "targetAudience") setTargetAudience("");
    else if (filterKey === "searchTerm") setSearchTerm("");
    else if (filterKey === "startDate") setDateRange([null, endDate]);
    else if (filterKey === "endDate") setDateRange([startDate, null]);
     else if (filterKey === "timezone") setTimeZone("");
  };
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 270,
      },
    },
  };
  const capabilityMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 270,
        left: {
          lg: "94px !important",
          xl: "109px !important",
        },
      },
    },
  };
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ borderBottom: "1px solid #D0CFCF", pb: 2, mb: 2 }}>
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", mx: "auto" }}
        >
          <TextField
            className="filter-dropdown"
            select
            label="Capability"
            value={capability}
            onChange={(e) => setCapability(e.target.value)}
            size="small"
            sx={{ width: 130,display:'none' }}
            SelectProps={{ MenuProps: capabilityMenuProps }}
          >
            {uniqueValues("Capability").map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            className="filter-dropdown"
            select
            label="Mode of Delivery"
            value={modeDelivery}
            onChange={(e) => setModeDelivery(e.target.value)}
            size="small"
            sx={{ width: 190 }}
          >
            {uniqueValues("ModeOfDelivery").map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            className="filter-dropdown"
            select
            label="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            size="small"
            sx={{ width: 120 }}
          >
            {uniqueValues("Category").map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            className="filter-dropdown"
            select
            label="Target Audience"
            value={targetAudience}
            onChange={(e) => setTargetAudience(e.target.value)}
            size="small"
            sx={{ width: 180 }}
            SelectProps={{ MenuProps: menuProps }}
          >
            {uniqueValues("TargetAudienceLevel").map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </TextField>
          
           {/* timezone dropdown  */}  
           <TextField
            className="filter-dropdown"
            select
            label="TimeZone"
            value={timezone?timezone[0].TimeZoneId:""}
            onChange={(e) => setTimeZone(requireValue().filter(i=>i.TimeZoneId === e.target.value))}
            size="small"
            sx={{ width: 120 }}
          >
             {requireValue().map((val) => (
              <MenuItem key={val} value={val.TimeZoneId}>
                {val.Country}
              </MenuItem>
            ))} 
          </TextField>


          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box display="flex" gap={2}>
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => setDateRange([newValue, endDate])}
                disablePast
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    className="filter-date"
                    sx={{ width: 130 }}
                  />
                )}
              />

              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => setDateRange([startDate, newValue])}
                disablePast
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    className="filter-date"
                    sx={{ width: 130 }}
                  />
                )}
              />
            </Box>
          </LocalizationProvider>

          <TextField
            label="Search..."
            size="small"
            value={searchTerm}
            className="filter-search"
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" aria-label="Search">
                  {searchTerm ? (
                    <IconButton onClick={() => setSearchTerm("")}>
                      <ClearIcon />
                    </IconButton>
                  ) : (
                    <SearchIcon />
                  )}
                </InputAdornment>
              ),
            }}
            sx={{ width: 180 }}
          />
          <Button
            onClick={handleDownload}
            variant="outlined"
            sx={{
              width: 140,
              height: "36px",
              fontSize: "0.8rem",
              fontFamily: "graphik-regular",
              color: "#000",
              borderColor: "#A100FF",
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 8px",
              "&:hover": {
                borderColor: "#A100FF",
                backgroundColor: "#f8f2ff",
              },
            }}
          >
            <span>Download</span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/LearningCalendar/download_icon.png"
              }
              alt="Download"
              style={{ width: 18, height: 18 }}
            />
          </Button>
        </Stack>
      </Box>
      <Stack direction="row" spacing={1} mt={2} flexWrap="wrap">
        {capability && (
          <Chip
            className="filter-chip"
            variant="outlined"
            label={capability}
            onDelete={() => handleDelete("capability")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
        {category && (
          <Chip
            className="filter-chip"
            variant="outlined"
            label={category}
            onDelete={() => handleDelete("category")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
        {modeDelivery && (
          <Chip
            className="filter-chip"
            variant="outlined"
            label={modeDelivery}
            onDelete={() => handleDelete("modeDelivery")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
        {targetAudience && (
          <Chip
            className="filter-chip"
            variant="outlined"
            label={targetAudience}
            onDelete={() => handleDelete("targetAudience")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
        {startDate && (
          <Chip
            variant="outlined"
            className="filter-chip"
            label={`Start Date: ${new Date(startDate).toLocaleDateString()}`}
            onDelete={() => handleDelete("startDate")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
        {endDate && (
          <Chip
            variant="outlined"
            className="filter-chip"
            label={`End Date: ${new Date(endDate).toLocaleDateString()}`}
            onDelete={() => handleDelete("endDate")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
       
        {timezone[0] && (
          <Chip
            variant="outlined"
            className="filter-chip"
            label={timezone[0].TimeZoneId}
            onDelete={() => handleDelete("timezone")}
            deleteIcon={
              <CloseIcon style={{ color: "#676767", fontSize: "15px" }} />
            }
          />
        )}
      </Stack>
    </Box>
  );
};

export default LearningCalendarFilters;
